import { App, Config } from 'ionic-angular';
import { SlideIn, SlideOut } from './slide-transitions';
import { Injectable } from '@angular/core';
import { Slide } from './slide';
var SlideController = (function () {
    function SlideController(_app, config) {
        this._app = _app;
        this.config = config;
        this.config.setTransition('slide-in', SlideIn);
        this.config.setTransition('slide-out', SlideOut);
    }
    SlideController.prototype.create = function (data, opts) {
        if (data === void 0) { data = {}; }
        if (opts === void 0) { opts = {}; }
        return new Slide(this._app, data, opts);
    };
    SlideController.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    SlideController.ctorParameters = function () { return [
        { type: App, },
        { type: Config, },
    ]; };
    return SlideController;
}());
export { SlideController };
//# sourceMappingURL=slide-controller.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ion2-image-slide/dist/components/slide-controller.js
// module id = 347
// module chunks = 20